module.exports = __webpack_public_path__ + "img/Cabbio.dc0d09f0.png";